<div class="footer mat-typography">{{'FOOTER.TEXT' | translate:{year: currentYear} }}</div>